import _extends from "@babel/runtime/helpers/extends";
import { Text } from '@carnica/ui-kit';
import React from 'react';
import { cnBem, getMessageText } from "../../../../shared/lib";
import { withMessageWrapper } from "../../lib";
import { CellsViewCell } from "./CellsViewCell";
import styles from "./styles.pcss";
var cnCellsView = cnBem('cells', styles);
var CellsViewRender = function CellsViewRender(props) {
  var items = props.items,
    description = props.description,
    message = props.message;
  var text = getMessageText(message);
  return /*#__PURE__*/React.createElement(React.Fragment, null, text && /*#__PURE__*/React.createElement(Text, {
    className: cnCellsView('text'),
    variant: "body-small"
  }, text), items === null || items === void 0 ? void 0 : items.map(function (item, i) {
    return /*#__PURE__*/React.createElement(CellsViewCell, _extends({}, item, {
      key: cnCellsView('item', {
        i: i
      }),
      withDivider: i !== items.length - 1
    }));
  }), description && /*#__PURE__*/React.createElement(Text, {
    className: cnCellsView('text'),
    color: "tertiary",
    variant: "body-paragraph-small"
  }, description));
};
export var CellsView = withMessageWrapper({
  offset: 'medium',
  wrapperClassName: cnCellsView()
})(CellsViewRender);